import { render, staticRenderFns } from "./uploadVideos.vue?vue&type=template&id=3156867b&scoped=true&"
import script from "./uploadVideos.vue?vue&type=script&lang=js&"
export * from "./uploadVideos.vue?vue&type=script&lang=js&"
import style0 from "./uploadVideos.vue?vue&type=style&index=0&id=3156867b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3156867b",
  null
  
)

export default component.exports